import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import axios from "axios";
import axiosInstance from "../../utils/axiosInstance";

const PdfViewerModels = ({ pdfUrl, open, onClose, data }) => {
  // console.log("data:::::::::::::::::::::", data);
  const token = localStorage.getItem("token");
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const handleShowTransection = async () => {
    try {
      const url = `/sendInvoiceToPartnerMonthly`;
      // const url = `${baseUrl}/sendInvoiceToPartnerMonthly`;
      const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const payload = {
        username: data?.username,
        pdfLink: data?.pdfLink,
        invoiceNo: data?.username,
        monthNameList: data?.monthNameList?.map((item) => item),
      };
      const response = await axiosInstance.post(url, payload);
      // const response = await axios.post(url, payload, { headers });
      //   console.log(
      //     "send links Response::::::::::::::::::::::::::::;:",
      //     response.data
      //   );
      if (!response.data.error) {
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire("Error", "Failed to send the email.", "error");
    }
  };
  return (
    <>
     {/*  */}
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        sx={{ zIndex: 1000, mt: 5 }}
      >
        <DialogTitle>
          Invoice PDF
          <div style={{ position: "absolute", right: 16, top: 8 }}>
            {pdfUrl && (
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={handleShowTransection}
              >
                Send Email
              </Button>
            )}
            <Tooltip title="Close">
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent>
          <iframe
            src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
            title="PDF Viewer"
            width="100%"
            height="500px"
            style={{ border: "none" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PdfViewerModels;

// import { Dialog, DialogTitle, DialogContent, IconButton, Button, Tooltip } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { sendInvoiceApi } from "../../app/slices/partnerInvoice/sendInvoiceSlice";
// import { useDispatch } from "react-redux";
// import Swal from "sweetalert2";  // Import SweetAlert2
// 

// const PdfViewerModal = ({ pdfUrl, open, onClose, _id, paymentStauts }) => {
//     const dispatch = useDispatch();

//     const handleShowTransection = async () => {
//         const result = await Swal.fire({
//             title: 'Are you sure?',
//             text: "Do you want to send this invoice via email?",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonText: 'Send',
//             cancelButtonText: 'Cancel',
//             customClass: {
//                 popup: 'custom-swal-popup',
//             },
//             willOpen: () => {
//                 const popup = document.querySelector('.custom-swal-popup');
//                 if (popup) {
//                     popup.style.zIndex = 4000;
//                 }
//             }
//         });

//         if (result.isConfirmed) {
//             const response = await dispatch(sendInvoiceApi({ _id }));
//             console.log("response: of email ", response);
//             if (response.meta.requestStatus === "fulfilled") {
//                 // Swal.fire('Send', 'Email send Successfully .', 'success');
//                 Swal.fire({
//                     title: 'Send',
//                     text: 'Email sent successfully.',
//                     icon: 'success',
//                     timer: 3000, // Auto close after 3 seconds (3000 milliseconds)
//                     showConfirmButton: false // Hide the "OK" button
//                 });

//                 setTimeout(() => {
//                     onClose();
//                 }, 3000);
//             }
//         } else {
//             Swal.fire('Cancelled', 'The action was cancelled.', 'error');
//         }
//     }

//     return (
//         <>
          
//             <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth sx={{ zIndex: 1000, mt: 5 }}>
//                 <DialogTitle>
//                     Invoice PDF
//                     <div style={{ position: "absolute", right: 16, top: 8 }}>
//                         {pdfUrl &&

//                             <Button variant={paymentStauts == "paid" ? "" : "contained"} color={"primary"} disabled={paymentStauts == "paid"} style={{ marginRight: 8 }} onClick={handleShowTransection}>
//                                 {paymentStauts == "paid" ? "Invoice Email Already Send" : "Send Email"}
//                             </Button>
//                         }
//                         <Tooltip title="Close" >
//                             <IconButton onClick={onClose}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </Tooltip>
//                     </div>
//                 </DialogTitle>
//                 <DialogContent>
//                         <iframe
//                             src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
//                             title="PDF Viewer"
//                             width="100%"
//                             height="500px"
//                             style={{ border: "none" }}
//                         />

//                 </DialogContent>
//             </Dialog>
//         </>
//     );
// };

// export default PdfViewerModal;
